module.exports = __webpack_public_path__ + "assets/img/search.108153ca.svg";